import Navigation from "../components/Navigation"
import ScrollAnimation from "../components/ScrollAnimation"
import LiveCounter from "../components/LiveCounter"
import TeamCarousel from "../components/TeamCarousel"
import { Link } from "react-router-dom"
import "./HomePage.scss"

const HomePage = () => {
  return (
    <div className="home-page">
      <Navigation />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <ScrollAnimation animation="fade-in-up">
            <div className="hero-content">
              <h1 className="hero-title">Cakoi's</h1>
              <p className="hero-description">
                Bringing you the authentic taste of traditional Malaysian cakoi and pau, made fresh daily with love and
                the finest ingredients. Experience the perfect blend of crispy, golden cakoi and soft, flavorful pau
                that brings families together.
              </p>
              <div className="hero-buttons">
                <Link to="/menu" className="btn btn-primary btn-lg">
                  View Our Menu
                </Link>
                <Link to="/partner" className="btn btn-outline btn-lg">
                  Become a Partner
                </Link>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </section>

      {/* Live Counter Section */}
      <section className="counter-section">
        <div className="container">
          <ScrollAnimation animation="fade-in-up" delay={200}>
            <div className="counter-content">
              <h2 className="section-title">Cakoi Served with Love</h2>
              <p className="section-subtitle">Join thousands of satisfied customers across Malaysia</p>
              <LiveCounter />
            </div>
          </ScrollAnimation>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="about-grid">
            <ScrollAnimation animation="fade-in-left">
              <div className="about-content">
                <h2 className="section-title">About Cakoi's</h2>
                <p className="about-text">
                  Founded with a passion for authentic Malaysian street food, Cakoi's has been serving communities
                  across the nation with our signature crispy cakoi and steamed pau since our humble beginnings.
                </p>
                <p className="about-text">
                  We believe in preserving traditional recipes while embracing modern quality standards. Every piece of
                  cakoi is hand-twisted and fried to golden perfection, while our pau are steamed fresh with premium
                  fillings that burst with flavor.
                </p>
                <div className="about-stats">
                  <div className="stat-item">
                    <div className="stat-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
                        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                        <path
                          d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                    <p className="stat-label">500+ Partners</p>
                  </div>
                  <div className="stat-item">
                    <div className="stat-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke="currentColor" strokeWidth="2" />
                        <polyline points="17,6 23,6 23,12" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </div>
                    <p className="stat-label">Growing Daily</p>
                  </div>
                  <div className="stat-item">
                    <div className="stat-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                    <p className="stat-label">Made with Love</p>
                  </div>
                </div>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animation="fade-in-right" delay={300}>
              <div className="about-image">
                <img
                  src="https://via.placeholder.com/600x500/CB0101/FFFFFF?text=Cakoi+Kitchen"
                  alt="Cakoi's kitchen and preparation"
                />
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      {/* Partner Promotion Section */}
      <section className="partner-promo-section">
        <div className="container">
          <ScrollAnimation animation="scale-in" delay={100}>
            <div className="promo-content">
              <h2 className="promo-title">LOOKING TO START A BUSINESS OR BOOST YOUR INCOME?</h2>
              <p className="promo-description">
                Join the Cakoi's family and start your own profitable food business with our proven system, training,
                and ongoing support.
              </p>
              <Link to="/partner" className="btn btn-white btn-lg">
                Become a Partner
              </Link>
            </div>
          </ScrollAnimation>
        </div>
      </section>

      {/* Team Stories Carousel */}
      <section className="stories-section">
        <div className="container">
          <ScrollAnimation animation="fade-in-up">
            <div className="stories-header">
              <h2 className="section-title">Our Team Stories</h2>
              <p className="section-subtitle">
                Real success stories from our partners who have transformed their lives with Cakoi's business
                opportunity.
              </p>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animation="fade-in-up" delay={200}>
            <TeamCarousel />
          </ScrollAnimation>
        </div>
      </section>

      {/* Contact Us Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <ScrollAnimation animation="fade-in-up">
            <div className="contact-header">
              <h2 className="section-title">Contact Us</h2>
              <p className="section-subtitle">
                Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
              </p>
            </div>
          </ScrollAnimation>

          <div className="contact-grid">
            <ScrollAnimation animation="fade-in-left" delay={200}>
              <div className="contact-info">
                <h3 className="contact-info-title">Get in Touch</h3>
                <div className="contact-items">
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                    <span>+60 12-345 6789</span>
                  </div>
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span>hello@cakois.com</span>
                  </div>
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" />
                      <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span>Kuala Lumpur, Malaysia</span>
                  </div>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="fade-in-right" delay={400}>
              <form className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name</label>
                    <input type="text" className="input" placeholder="Your first name" />
                  </div>
                  <div className="form-group">
                    <label>Last Name</label>
                    <input type="text" className="input" placeholder="Your last name" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" className="input" placeholder="your.email@example.com" />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" className="input" placeholder="What's this about?" />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea className="textarea" placeholder="Tell us more about your inquiry..." rows="5"></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-lg">
                  Send Message
                </button>
              </form>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3 className="footer-title">Cakoi's</h3>
              <p className="footer-text">Authentic Malaysian cakoi and pau, made fresh daily with love.</p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/menu">Menu</Link>
                </li>
                <li>
                  <Link to="/partner">Become a Partner</Link>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Business</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/partner">Partnership</Link>
                </li>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#">Franchise</a>
                </li>
                <li>
                  <a href="#">Support</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
                <li>
                  <a href="#">WhatsApp</a>
                </li>
                <li>
                  <a href="#">TikTok</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Cakoi's. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default HomePage
